import React from "react";

const CheckoutFooter = () => {
    return (
        <div
            className="w-full flex-1 mt-2 md:mt-0 bg-cartItem rounded-t-[2rem] px-8 py-2 flex flex-col items-center justify-center">
            <div className="flex items-center justify-center gap-2">
            </div>
        </div>
    );
};

export default CheckoutFooter;
